import type { EventCallback, EventName } from "@tauri-apps/api/event";
import type { Tauri } from ".";

export class NullTauri implements Tauri {
  get enabled() {
    return false;
  }

  invoke<T>(_command: string, _args?: Record<string, any>): Promise<T> {
    throw new Error("Tauri is not enabled");
  }

  emit(_event: string, _data: any) {
    throw new Error("Tauri is not enabled");
  }

  listen<Event>(_event: EventName, _callback: EventCallback<Event>): Promise<() => void> {
    throw new Error("Tauri is not enabled");
  }

  async checkUpdate(_channel?: "beta" | "release") {
    return Promise.resolve({
      shouldUpdate: false,
      manifest: {
        version: "0.0.0",
        date: null,
        body: "No updates available in NullTauri mode.",
      },
    });
  }

  async getUpdateForChannel(_channel: "beta" | "release"): Promise<boolean> {
    throw new Error("Tauri is not enabled");
  }

  async downloadUpdateForLater(_channel: "beta" | "release"): Promise<void> {
    throw new Error("Tauri is not enabled");
  }

  async installCachedUpdate(): Promise<boolean> {
    throw new Error("Tauri is not enabled");
  }

  async downloadAndInstallUpdate(_channel: "beta" | "release"): Promise<void> {
    throw new Error("Tauri is not enabled");
  }

  async getUpdateChannel(): Promise<"beta" | "release"> {
    throw new Error("Tauri is not enabled");
  }

  async setUpdateChannel(_channel: "beta" | "release"): Promise<void> {
    throw new Error("Tauri is not enabled");
  }

  performSync(): Promise<unknown> {
    throw new Error("Tauri is not enabled");
  }

  getCloseToTrayEnabled(): Promise<boolean> {
    throw new Error("Tauri is not enabled");
  }

  setCloseToTrayEnabled(_enabled: boolean): Promise<void> {
    throw new Error("Tauri is not enabled");
  }
}
